(() => {
  if (window.fxlServiceV2Loaded) return;
  window.fxlServiceV2Loaded = true;
  const mobile = window.matchMedia('(max-width: 1200px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();
  function init(root = document) {
    root.querySelectorAll('[data-fxls-top]').forEach(bar => {
      if (instances.has(bar)) return;
      const list = bar.querySelector('[data-fxls-benefits]');
      const prev = bar.querySelector('[data-fxls-prev]');
      const next = bar.querySelector('[data-fxls-next]');
      if (!list || !prev || !next) return;
      const controller = new AbortController();
      const { signal } = controller;
      function update() {
        const compact = mobile.matches;
        prev.hidden = next.hidden = !compact || list.children.length < 2;
        prev.disabled = list.scrollLeft < 2;
        next.disabled = list.scrollLeft >= list.scrollWidth - list.clientWidth - 2;
        Array.from(list.children).forEach(item => {
          const visible = !compact || Math.abs(item.offsetLeft - list.firstElementChild.offsetLeft - list.scrollLeft) < list.clientWidth / 2;
          item.querySelectorAll('a').forEach(a => a.tabIndex = visible ? 0 : -1);
        });
      }
      function move(direction) {
        const index = Math.round(list.scrollLeft / list.clientWidth);
        list.scrollTo({ left: (index + direction) * list.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth' });
      }
      prev.addEventListener('click', () => move(-1), { signal });
      next.addEventListener('click', () => move(1), { signal });
      list.addEventListener('scroll', update, { signal, passive: true });
      window.addEventListener('resize', update, { signal, passive: true });
      update();
      instances.set(bar, controller);
    });
    root.querySelectorAll('[data-fxls-topic]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      const hints = select.closest('form').querySelector('[data-fxls-topic-help]');
      if (!hints) return;
      function update() {
        const topic = select.selectedOptions[0]?.dataset.topic;
        hints.hidden = !['delivery', 'return'].includes(topic);
        hints.querySelectorAll('[data-fxls-help]').forEach(p => p.hidden = p.dataset.fxlsHelp !== topic);
      }
      select.addEventListener('change', update);
      update();
    });
    const feedback = root.querySelector('[data-fxls-feedback]');
    if (feedback) feedback.focus({ preventScroll: false });
  }
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-fxls-chat]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    const status = link.parentElement.querySelector('[data-fxls-chat-status]');
    const fallback = status?.textContent;
    link.setAttribute('aria-busy', 'true');
    if (status) { status.hidden = false; status.textContent = link.dataset.loading; }
    let opened = false;
    const deadline = Date.now() + 6000;
    while (Date.now() < deadline && link.isConnected) {
      if (typeof window.ysa_openChat === 'function') {
        try { opened = window.ysa_openChat() !== false; } catch { opened = false; }
        break;
      }
      await new Promise(resolve => setTimeout(resolve, 200));
    }
    link.removeAttribute('aria-busy');
    if (status) { status.textContent = fallback; status.hidden = opened; }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [bar, controller] of instances) {
      if (event.target.contains(bar)) { controller.abort(); instances.delete(bar); }
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();


